const TOKENS_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const TOKENS_SORT_KEYS = {
  TOKEN_NAME: 0,
  TOKEN_SYMBOL: 1,
  TOKEN_ADDRESS: 2,
};

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const tokenSortKeys = [
  { name: 'Token Name', key: 'name' },
  { name: 'Token Symbol', key: 'symbol' },
  { name: 'Token Address', key: 'address' },
];

const nftSortKeys = [
  { name: 'NFT Name', key: 'name' },
  { name: 'NFT Address', key: 'address' },
  { name: 'NFT URL', key: 'url' },
];

const sortKeys = tokenSortKeys;

const getSortKeysBySalesType = (salesType) => {
  return salesType === 'nft' ? nftSortKeys : tokenSortKeys;
};

const getSortKeyField = (salesType, sortKeyIndex) => {
  const resolvedSortKeys = getSortKeysBySalesType(salesType);
  return resolvedSortKeys?.[sortKeyIndex]?.key || resolvedSortKeys?.[0]?.key || 'name';
};

export {
  TOKENS_SORT_TYPES,
  TOKENS_SORT_KEYS,
  sortTypes,
  sortKeys,
  tokenSortKeys,
  nftSortKeys,
  getSortKeysBySalesType,
  getSortKeyField,
};
